// extracted by mini-css-extract-plugin
export var createdDate = "_m1-1";
export var divider = "_m1-2";
export var headerDivider = "_m1-3";
export var messagesCard = "_m1-0";
export var messagesContainer = "_m1-6";
export var messagesContainerWrapper = "_m1-4";
export var showLeftPanelButton = "_m1-8";
export var topButtons = "_m1-7";
export var withPadding = "_m1-5";